import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

/* eslint-disable max-len */
const ErrorIcon: React.FunctionComponent<SvgIconProps> = props => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path fill="#F39B00" d="M8 2l7 12H1z" />
      <path fill="#FFF" d="M9 11v2H7v-2h2zm0-5v4H7V6h2z" />
    </g>
  </SvgIcon>
);

export default ErrorIcon;
